export function formatRegistrationFieldMessage(field, message) {
  if (field === "username" && message.includes("already exists")) {
    return "Username already taken.";
  }
  return message;
}

export function showRegistrationApiErrors(errorData, toast, options = {}) {
  const { fallbackMessage } = options;
  if (!errorData) {
    return false;
  }

  let errorShown = false;

  if (errorData.user) {
    Object.entries(errorData.user).forEach(([field, messages]) => {
      messages.forEach((message) => {
        const formatted = formatRegistrationFieldMessage(field, message);
        toast.error(
          `${field.charAt(0).toUpperCase() + field.slice(1)}: ${formatted}`
        );
      });
    });
    errorShown = true;
  }

  if (errorData.error) {
    toast.error(errorData.error);
    errorShown = true;
  }

  if (errorData.detail) {
    toast.error(errorData.detail);
    errorShown = true;
  }

  if (!errorShown && fallbackMessage) {
    toast.error(fallbackMessage);
    errorShown = true;
  }

  return errorShown;
}
